<template>
  <div class="flex flex-wrap items-end gap-3">
    <div class="flex-1 min-w-[140px]">
      <label class="mb-1 block text-xs font-medium text-dark/70" for="search">Name</label>
      <input id="search" v-model="filters.name" type="text" name="search" placeholder="Search by name..."
        class="h-9 w-full border max-w-xl rounded-lg border-gray-300 bg-transparent px-3 text-sm font-medium text-dark outline-none transition-colors placeholder:text-grey-300 focus:border-primary focus:ring-1 focus:ring-primary" />
    </div>
    <div class="w-50 shrink-0">
      <label class="mb-1 block text-xs font-medium text-dark/70" for="region">Region</label>
      <select id="region" v-model="filters.region" name="region"
        class="h-9 w-full border max-w-xl rounded-lg border-gray-300 bg-transparent px-3 text-sm font-medium text-dark outline-none transition-colors focus:border-primary focus:ring-1 focus:ring-primary">
        <option value="">All regions</option>
        <option v-for="r in regions" :key="r" :value="r">{{ r }}</option>
      </select>
    </div>
    <div class="w-50 shrink-0">
      <label class="mb-1 block text-xs font-medium text-dark/70" for="category">Category</label>
      <select id="category" v-model="filters.category" name="category"
        class="h-9 w-full border max-w-xl rounded-lg border-gray-300 bg-transparent px-3 text-sm font-medium text-dark outline-none transition-colors focus:border-primary focus:ring-1 focus:ring-primary">
        <option value="">All categories</option>
        <option v-for="c in categories" :key="c" :value="c">{{ c }}</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  partners: {
    type: Array,
    default: () => []
  }
})

const filters = defineModel('filters', { type: Object, required: true })

const regions = computed(() => {
  const set = new Set()
  props.partners.forEach(p => (p.regions || []).forEach(r => set.add(r)))
  return [...set].sort()
})

const categories = computed(() => {
  const set = new Set()
  props.partners.forEach(p => (p.categories || []).forEach(c => set.add(c)))
  return [...set].sort()
})

defineEmits(['search'])
</script>
